export enum SanityInputFieldType {
  Checkbox = "inputCheckbox",
  Checkboxes = "inputCheckboxes",
  Datetime = "inputDatetimePicker",
  Dropdown = "inputDropdown",
  Email = "inputEmail",
  FileUpload = "inputFileUpload",
  FormHeading = "formHeading",
  Number = "inputNumber",
  Password = "inputPassword",
  PostalCode = "inputPostalCode",
  PriceCheckboxes = "inputPriceCheckboxes",
  PriceRadioButtons = "inputPriceRatioButtons",
  RadioButtons = "inputRadioButtons",
  TermsAndConditions = "inputTermsAndConditions",
  Text = "inputText",
  TextArea = "inputTextArea"
}
